import { Link } from "react-router-dom";
import { Instagram, Mail, MapPin, Phone } from "lucide-react";
import { ASSETS, CONTACT, GALLERY_IMAGES } from "@/data/site";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="noise-overlay bg-obsidian text-stone-300">
      <div className="overflow-hidden border-b border-gold/10 py-10" data-testid="footer-gallery-marquee">
        <div className="marquee-track gap-5">
          {[...GALLERY_IMAGES, ...GALLERY_IMAGES].map((src, i) => (
            <img
              key={i}
              src={src}
              alt="ShilpStones Creations work"
              loading="lazy"
              className="h-56 w-auto shrink-0 rounded-xl object-cover spotlight-frame sm:h-72"
            />
          ))}
        </div>
      </div>
      <div className="mx-auto max-w-7xl px-6 py-16 sm:px-12 lg:px-20">
        <div className="grid gap-12 md:grid-cols-2 lg:grid-cols-4">
          <div>
            <div className="flex items-center gap-3">
              <img src={ASSETS.logo} alt="ShilpStones logo" className="h-12 w-12 rounded-full ring-1 ring-gold/50 object-cover" />
              <div>
                <p className="font-serif text-xl text-stone-100">ShilpStones</p>
                <p className="font-display text-[10px] tracking-[0.4em] text-gold-soft">CREATIONS</p>
              </div>
            </div>
            <p className="mt-5 text-sm leading-relaxed text-stone-400">
              Where stone becomes art.
            </p>
            <p className="mt-4 font-display text-[11px] tracking-[0.35em] text-gold">
              NATURE &nbsp;•&nbsp; DESIGN &nbsp;•&nbsp; LEGACY
            </p>
          </div>

          <div>
            <p className="eyebrow-light mb-5">Explore</p>
            <ul className="space-y-3 text-sm">
              <li><Link data-testid="footer-link-projects" to="/projects" className="transition-colors hover:text-gold">Signature Projects</Link></li>
              <li><Link data-testid="footer-link-expertise" to="/expertise" className="transition-colors hover:text-gold">Our Expertise</Link></li>
              <li><Link data-testid="footer-link-collections" to="/collections" className="transition-colors hover:text-gold">Collections & Brochure</Link></li>
              <li><Link data-testid="footer-link-heritage" to="/#heritage" className="transition-colors hover:text-gold">Craft & Heritage</Link></li>
              <li><Link data-testid="footer-link-contact" to="/contact" className="transition-colors hover:text-gold">Contact</Link></li>
            </ul>
          </div>

          <div>
            <p className="eyebrow-light mb-5">Contact</p>
            <ul className="space-y-3 text-sm">
              {CONTACT.phones.map((p) => (
                <li key={p.tel} className="flex items-center gap-2">
                  <Phone className="h-3.5 w-3.5 text-gold" />
                  <a href={`tel:${p.tel}`} className="transition-colors hover:text-gold">{p.label}</a>
                </li>
              ))}
              <li className="flex items-center gap-2">
                <Mail className="h-3.5 w-3.5 shrink-0 text-gold" />
                <a href={`mailto:${CONTACT.email}`} className="break-all transition-colors hover:text-gold">{CONTACT.email}</a>
              </li>
              <li className="flex items-center gap-2">
                <Instagram className="h-3.5 w-3.5 shrink-0 text-gold" />
                <a
                  href="https://instagram.com/shilpstonescreations"
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid="footer-instagram-link"
                  className="transition-colors hover:text-gold"
                >
                  @shilpstonescreations
                </a>
              </li>
            </ul>
          </div>

          <div>
            <p className="eyebrow-light mb-5">Studio</p>
            <ul className="space-y-4 text-sm">
              {CONTACT.addresses.map((a) => (
                <li key={a.label} className="flex gap-2">
                  <MapPin className="mt-0.5 h-3.5 w-3.5 shrink-0 text-gold" />
                  <span>
                    <span className="block text-stone-400">{a.label}</span>
                    {a.value}
                  </span>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-14 flex flex-col items-center justify-between gap-4 border-t border-gold/10 pt-8 text-xs text-stone-500 sm:flex-row">
          <p>© {new Date().getFullYear()} ShilpStones Creations. Where stone becomes art.</p>
          <div className="flex items-center gap-5">
            <Link to="/collections" data-testid="footer-collections-link" className="tracking-[0.2em] uppercase text-gold transition-colors hover:text-gold-glow">
              View Collections
            </Link>
            <Link to="/admin" data-testid="footer-admin-link" className="tracking-[0.2em] uppercase transition-colors hover:text-gold">
              Studio Login
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
